/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Remove_Team_SuccessInputs */



/**
* | output |
* | --- |
* | "Team removed from space successfully!" |
*
* @param {Spaces_Remove_Team_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_remove_team_success = /** @type {((inputs?: Spaces_Remove_Team_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Remove_Team_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Team erfolgreich aus dem Speicherplatz entfernt!")
	return /** @type {LocalizedString} */ ("Team removed from space successfully!")
});